/**
 * Created by OBL on 14/01/2016.
 */
define('adminSettingController',[
    'module',
    'underscore',
    'app',
    'adminSettingView',
    'bootbox',
    'settingCreateEditLayoutView',
    'settings',
    'entities/setting'
], function(
    module,
    _,
    App,
    View,
    bootbox,
    CreateEditLayoutView
    ) {
    'use strict';

    var AdminSettingListController = {
        showSettingList: function(data) {
            var view = new View({data: data});
            this.view = view;
            view.listenTo(view, 'onGridLoaded', _.bind(this.onGridLoaded, this));
            view.listenTo(view, 'setting:delete', _.bind(this.onDelete, this));
            App.regions.getRegion('main').currentView.getRegion('content').show(view);
        },

        showSettingAdd: function() {
            this.createEditView = new CreateEditLayoutView({
                settingModel: App.request('setting:model'),
                newItem: true
            });
            this.createEditView.show({
                title: _.i18n('setting.new')
            });
        },

        onGridLoaded: function() {
            var data = {
                url: App.request('setting:get-collection-url'),
                rowCountUrl: App.request('setting:get-count-url')
            };

            this.view.displayGrid(data);
        },

        onDelete: function(secId){
            bootbox.confirm(_.i18n('setting.confirmDelete'), _.bind(function(result) {
                if(result){
                    App.request('setting:delete', secId)
                        .done(_.bind(function(){
                            this.view.updatePagination('reloadGrid');
                        }, this));
                }
            }, this));
        }
    };

    module.exports = AdminSettingListController;
});
